<template>
  <v-dialog
    :value="Boolean(active)"
    max-width="480"
    persistent
    :retain-focus="Boolean(active)"
    content-class="confirmation-dialog"
  >
    <v-card
      v-if="active"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="confirmation-title"
      aria-describedby="confirmation-message"
      class="rounded-lg"
    >
      <v-card-title class="flex-nowrap align-start pa-6 pb-4">
        <v-avatar
          :color="active.color === 'error' ? 'errorVariant' : 'primaryVariant'"
          size="44"
          class="mr-4"
        >
          <v-icon :color="active.color">
            {{ active.icon }}
          </v-icon>
        </v-avatar>
        <span
          id="confirmation-title"
          class="text-h6 confirmation-dialog__title"
        >{{ active.title }}</span>
      </v-card-title>

      <v-card-text
        id="confirmation-message"
        class="px-6 pb-6 text-body-1 confirmation-dialog__message"
      >
        {{ active.message }}
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4 flex-wrap">
        <span class="text-caption text--secondary ml-2">Enter para confirmar</span>
        <v-spacer />
        <v-btn
          ref="cancelButton"
          text
          @click="answer(false)"
        >
          {{ active.cancelText }}
        </v-btn>
        <v-btn
          :color="active.color"
          depressed
          @click="answer(true)"
        >
          {{ active.confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { confirmation } from '@/plugins/confirmation'

  export default {
    name: 'ConfirmationDialog',

    data: () => ({ state: confirmation.state, enterPressed: false, enterAccepted: true }),

    computed: {
      active () {
        return this.state.active
      },
    },

    watch: {
      active () {
        this.enterPressed = false
      },
      $route () {
        confirmation.cancel()
      },
    },

    mounted () {
      document.addEventListener('keydown', this.onKeydown, true)
      document.addEventListener('keyup', this.onKeyup, true)
    },

    beforeDestroy () {
      confirmation.cancel()
      document.removeEventListener('keydown', this.onKeydown, true)
      document.removeEventListener('keyup', this.onKeyup, true)
    },

    methods: {
      answer (accepted) {
        confirmation.answer(accepted)
      },

      onKeydown (event) {
        if (!this.active || !['Enter', 'Escape'].includes(event.key)) {
          return
        }
        event.preventDefault()
        event.stopImmediatePropagation()
        if (event.key === 'Enter' && !event.repeat && !event.isComposing) {
          const cancelButton = this.$refs?.cancelButton?.$el
          this.enterAccepted = !(cancelButton && (cancelButton === event.target || cancelButton.contains(event.target)))
          this.enterPressed = true
        }
      },

      onKeyup (event) {
        if (!this.active || !['Enter', 'Escape'].includes(event.key)) {
          return
        }
        event.preventDefault()
        event.stopImmediatePropagation()
        // Require a fresh key press inside this dialog. The keyup that opened
        // it must not confirm it, nor trigger shortcuts on the form behind it.
        if (event.key === 'Enter' && this.enterPressed && !event.isComposing) {
          this.enterPressed = false
          this.answer(this.enterAccepted)
        }
      },
    },
  }
</script>

<style scoped>
.confirmation-dialog__title {
  overflow-wrap: anywhere;
  white-space: normal;
  line-height: 1.5;
}

.confirmation-dialog__message {
  white-space: pre-line;
  overflow-wrap: anywhere;
  max-height: 55vh;
  overflow-y: auto;
}
</style>
